export enum UserRoleE {
  GlobalAdmin = "GlobalAdmin", // *
  AdminContentManager = "AdminContentManager", // *
  GlobalAdminAndAdminContentManager = "GlobalAdmin,AdminContentManager",

  AdvertisingAgency_Admin = "AdvertisingAgency_Admin",
  AdvertisingAgency_User = "AdvertisingAgency_User",
  AdvertisingAgency_Guest = "AdvertisingAgency_Guest",
  AdvertisingAgency = "AdvertisingAgency_Admin,AdvertisingAgency_User,AdvertisingAgency_Guest", // *
  AdvertisingAgencyNonGuest = "AdvertisingAgency_Admin,AdvertisingAgency_User",

  Advertiser_Anonymous = "Advertiser_Anonymous",

  PostProduction_Admin = "PostProduction_Admin",
  PostProduction_User = "PostProduction_User",
  PostProduction_Guest = "PostProduction_Guest",
  PostProduction = "PostProduction_Admin,PostProduction_User,PostProduction_Guest", // *
  PostProductionNonGuest = "PostProduction_Admin,PostProduction_User",

  Production_Admin = "Production_Admin",
  Production_User = "Production_User",
  Production_Guest = "Production_Guest",
  Production = "Production_Admin,Production_User,Production_Guest",
  ProductionNonGuest = "Production_Admin,Production_User",

  Broadcaster_Admin = "Broadcaster_Admin",
  Broadcaster_User = "Broadcaster_User",
  Broadcaster_Guest = "Broadcaster_Guest",
  Broadcaster = "Broadcaster_Admin,Broadcaster_User,Broadcaster_Guest", // *
  BroadcasterNonGuest = "Broadcaster_Admin,Broadcaster_User",

  RadioStation_Admin = "RadioStation_Admin",
  RadioStation_User = "RadioStation_User",
  RadioStation_Guest = "RadioStation_Guest",
  RadioStation = "RadioStation_Admin,RadioStation_User,RadioStation_Guest",
  RadioStationNonGuest = "RadioStation_Admin,RadioStation_User",

  MediaCompany_Admin = "MediaCompany_Admin",
  MediaCompany_User = "MediaCompany_User",
  MediaCompany_Guest = "MediaCompany_Guest",
  MediaCompany = "MediaCompany_Admin,MediaCompany_User,MediaCompany_Guest",
  MediaCompanyNonGuest = "MediaCompany_Admin,MediaCompany_User",

  DeliveryService_Admin = "DeliveryService_Admin",
  DeliveryService_User = "DeliveryService_User",
  DeliveryService = "DeliveryService_Admin,DeliveryService_User", // *
  DeliveryServiceNonGuest = "DeliveryService_Admin,DeliveryService_User",

  ClientAdmins = "AdvertisingAgency_Admin,PostProduction_Admin,Broadcaster_Admin,RadioStation_Admin,MediaCompany_Admin,DeliveryService_Admin",
  ClientUsers = "AdvertisingAgency_User,PostProduction_User,Broadcaster_User,RadioStation_User,MediaCompany_User,DeliveryService_User",
  ClientGuests = "AdvertisingAgency_Guest,PostProduction_Guest,Broadcaster_Guest,RadioStation_Guest,MediaCompany_Guest",

  AllButGlobalAdmin = "AdvertisingAgency,PostProduction,Broadcaster,RadioStation,MediaCompany,DeliveryService",
  AllButGlobalAdminAndGuests = "AdvertisingAgencyNonGuest,PostProductionNonGuest,BroadcasterNonGuest,RadioStationNonGuest,MediaCompanyNonGuest,DeliveryServiceNonGuest",
  AllButDelivery = "GlobalAdminAndAdminContentManager,PostProduction,Production,Broadcaster,RadioStation,MediaCompany,AdvertisingAgency",

  All = "AdminContentManager,AdvertisingAgency,PostProduction,Broadcaster,RadioStation,MediaCompany,GlobalAdmin,DeliveryService",
}

export enum AccessLevelUserManagementE {
  Admin = 0,
  User = 1,
  Guest = 2,
  "Delivery Service Private" = 4,
}

export enum AccessLevelUserManagementHeE {
  אדמין = 0,
  משתמש = 1,
  אורח = 2,
  "שירות משלוחים פרטי" = 4,
}

export enum AccessLevelE {
  Admin = 0,
  User = 1,
  Guest = 2,
  GlobalAdmin = 3,
  DeliveryServicePrivate = 4,
}

export enum AccessLevelHeE {
  אדמין = 0,
  משתמש = 1,
  אורח = 2,
  "מנהל כללי" = 3,
  "שירות משלוחים פרטי" = 4,
}

export enum StatusE {
  DownloadedByBroadcaster = "DownloadedByBroadcaster",
  Deleted = "Deleted",
  Rejected = "Rejected",
  Opened = "Opened",
  Closed = "Closed",
  DownloadedByAllBroadcasters = "DownloadedByAllBroadcasters",
  ApprovedAndSentToBroadcaster = "ApprovedAndSentToBroadcaster",
  Creating = "Creating",
  Editing = "Editing",
  UploadingFiles = "UploadingFiles",
  WaitingForApprovalOfPostProduction = "WaitingForApprovalOfPostProduction",
  WaitingForApprovalOfAdvertisingAgency = "WaitingForApprovalOfAdvertisingAgency",
  Cancelled = "Cancelled",
  InnerCampaign = "InnerCampaign",
  Metadata = "Metadata",
}

export enum ProjectStatusE {
  Creating = 9,

  // Project is opened by advertising agency. There is an order for post/sound production company
  // to process the project.
  Opened = 0,

  // Project is editing by advertising agency. It's not possible to upload files for this
  // project when it has this status.
  Editing = 1,

  // Post/sound production company has started uploading files for the project
  UploadingFiles = 2,

  // Waiting for approval of post production company. This status is assigned after
  // post/sound production company uploaded files for the project.
  WaitingForApprovalOfPostProduction = 3,

  // Waiting for approval of advertising agency. This status is assigned after
  // post/sound production company uploaded and approved files for the project.
  WaitingForApprovalOfAdvertisingAgency = 4,

  // The project is approved by advertising agency and sent to broadcaster
  ApprovedAndSentToBroadcaster = 5,

  // Files for this project are downloaded by broadcaster
  DownloadedByBroadcaster = 6,

  // The project is closed automatically one week after files are downloaded by broadcaster
  Closed = 7,

  // The project is cancelled by advertising agency
  Cancelled = 8,

  // the project was deleted
  Deleted = 10,

  // the project was rejected
  Rejected = 11,

  // Files for this project are downloaded by all brodcasters
  DownloadedByAllBroadcasters = 100,

  //is a inner campaign created by broadcaster
  InnerCampaign = 200,

  // campaign without delivery data (no versions and broadcasters)
  Metadata = 300,
}

export enum StatusColorE {
  Creating = "#254FE4",
  DownloadedByBroadcaster = "#E4006E",
  Opened = "#2491D8",
  Closed = "#B20EB5",
  Deleted = "#FF0000",
  DownloadedByAllBroadcasters = "#E4006E",
  ApprovedAndSentToBroadcaster = "#F04422",
  Editing = "#24AE95",
  UploadingFiles = "#67BB46",
  WaitingForApprovalOfPostProduction = "#FEC92E",
  WaitingForApprovalOfAdvertisingAgency = "#F59023",
  Cancelled = "#FF0000",
  InnerCampaign = "#B6887E",
  Rejected = "#797979",
}

export enum VideoContentStatusE {
  WAITING = "Waiting", // File (version) is defined but is not uploaded yet
  UPLOADING = "Uploading", // File is being uploaded
  UPLOADED = "Uploaded", // File uploaded
  ENCODING = "Encoding", // File is sent for encoding but the encoding process isn't finished yet
  ENCODED = "Encoded", // The file is successfully encoded, it is possible to show low-res version on site
  ENCODING_ERROR = "EncodingError", // Encoding has failed
  UPLOADED_ERROR = "UploadError", // Upload of the file failed
  LOW_RES_ONLY = "LowResOnly", // Low-res version only is available, high-res version has been deleted from server
  DELETED = "Deleted", // Both low-res and high-res versions of the files has been deleted from the server
}

export enum VideoContentStatusEnE {
  "Waiting" = "Waiting",
  "Uploading" = "Uploading",
  "Uploaded" = "Uploaded",
  "Encoding" = "Encoding",
  "Encoded" = "Encoded",
  "EncodingError" = "Encoding Error",
  "UploadError" = "Upload Error",
  "LowResOnly" = "Low Resolution Only",
  "Deleted" = "Deleted",
}

export enum VideoContentFormatE {
  MP4 = "MP4",
  AVI = "AVI",
}

// app content ---------START------------

export enum DirectionE {
  LTR = "ltr",
  RTL = "rtl",
}

export enum LangE {
  EN = "en",
  HE = "he",
}

export enum CultureE {
  "en-US" = "English",
  "he-IL" = "Hebrew",
}

export enum CultureCodeE {
  EN = "en-US",
  HE = "he-IL",
}

// app content ---------END------------

// global icons ---------START------------

export enum IconSizeE {
  XS,
  S,
  M,
  L,
  XL,
  XXL,
}

export enum IconColorE {
  WHITE = "white",
  BLACK = "black",
  BLUE = "blue",
  PASTEL_BLUE = "pastelBlue",
  GRAY = "gray",
  LIGHT_GRAY = "lightGray",
  DARK_GRAY = "darkGray",
  ORANGE = "orange",
  GREEN = "green", // spec 48 — $campaign #44A675, for icons inside outlined/link campaign buttons
  NONE = "none",
}

// global icons ---------END------------

export enum ProfilePhotoSizeE {
  LARGE = "large",
  MIDDLE = "middle",
  SMALL = "small",
}

export enum TooltipPlaceE {
  RIGHT = "right",
  LEFT = "left",
  TOP = "top",
  BOTTOM = "bottom",
}

export enum ClientTypeE {
  "Advertising Agency" = 0,
  "Post/sound production" = 2,
  "Broadcaster" = 3,
  "Radio station" = 4,
  "Delivery service" = 5,
  "Production company" = 6,
  "Media Company" = 7,
}

export enum ClientSubtypeE {
  "None",
  "Broadcaster - Cinema",
}

export enum NotificationTypeE {
  "Popup" = 0,
  "Campaign" = 1,
}

export enum ProjectCommentType {
  General = 0,
  ForBroadcastersWhenSendingProject = 1,
}

export enum CountryE {
  "AF" = "Afghanistan",
  "AX" = "Åland Islands",
  "AL" = "Albania",
  "DZ" = "Algeria",
  "AS" = "American Samoa",
  "AD" = "AndorrA",
  "AO" = "Angola",
  "AI" = "Anguilla",
  "AQ" = "Antarctica",
  "AG" = "Antigua and Barbuda",
  "AR" = "Argentina",
  "AM" = "Armenia",
  "AW" = "Aruba",
  "AU" = "Australia",
  "AT" = "Austria",
  "AZ" = "Azerbaijan",
  "BS" = "Bahamas",
  "BH" = "Bahrain",
  "BD" = "Bangladesh",
  "BB" = "Barbados",
  "BY" = "Belarus",
  "BE" = "Belgium",
  "BZ" = "Belize",
  "BJ" = "Benin",
  "BM" = "Bermuda",
  "BT" = "Bhutan",
  "BO" = "Bolivia",
  "BA" = "Bosnia and Herzegovina",
  "BW" = "Botswana",
  "BV" = "Bouvet Island",
  "BR" = "Brazil",
  "IO" = "British Indian Ocean Territory",
  "BN" = "Brunei Darussalam",
  "BG" = "Bulgaria",
  "BF" = "Burkina Faso",
  "BI" = "Burundi",
  "KH" = "Cambodia",
  "CM" = "Cameroon",
  "CA" = "Canada",
  "CV" = "Cape Verde",
  "KY" = "Cayman Islands",
  "CF" = "Central African Republic",
  "TD" = "Chad",
  "CL" = "Chile",
  "CN" = "China",
  "CX" = "Christmas Island",
  "CC" = "Cocos (Keeling) Islands",
  "CO" = "Colombia",
  "KM" = "Comoros",
  "CG" = "Congo",
  "CD" = "Congo, The Democratic Republic of the",
  "CK" = "Cook Islands",
  "CR" = "Costa Rica",
  "CI" = "Cote D'Ivoire",
  "HR" = "Croatia",
  "CU" = "Cuba",
  "CY" = "Cyprus",
  "CZ" = "Czech Republic",
  "DK" = "Denmark",
  "DJ" = "Djibouti",
  "DM" = "Dominica",
  "DO" = "Dominican Republic",
  "EC" = "Ecuador",
  "EG" = "Egypt",
  "SV" = "El Salvador",
  "GQ" = "Equatorial Guinea",
  "ER" = "Eritrea",
  "EE" = "Estonia",
  "ET" = "Ethiopia",
  "FK" = "Falkland Islands (Malvinas)",
  "FO" = "Faroe Islands",
  "FJ" = "Fiji",
  "FI" = "Finland",
  "FR" = "France",
  "GF" = "French Guiana",
  "PF" = "French Polynesia",
  "TF" = "French Southern Territories",
  "GA" = "Gabon",
  "GM" = "Gambia",
  "GE" = "Georgia",
  "DE" = "Germany",
  "GH" = "Ghana",
  "GI" = "Gibraltar",
  "GR" = "Greece",
  "GL" = "Greenland",
  "GD" = "Grenada",
  "GP" = "Guadeloupe",
  "GU" = "Guam",
  "GT" = "Guatemala",
  "GG" = "Guernsey",
  "GN" = "Guinea",
  "GW" = "Guinea-Bissau",
  "GY" = "Guyana",
  "HT" = "Haiti",
  "HM" = "Heard Island and Mcdonald Islands",
  "VA" = "Holy See (Vatican City State)",
  "HN" = "Honduras",
  "HK" = "Hong Kong",
  "HU" = "Hungary",
  "IS" = "Iceland",
  "IN" = "India",
  "ID" = "Indonesia",
  "IR" = "Iran, Islamic Republic Of",
  "IQ" = "Iraq",
  "IE" = "Ireland",
  "IM" = "Isle of Man",
  "IL" = "Israel",
  "IT" = "Italy",
  "JM" = "Jamaica",
  "JP" = "Japan",
  "JE" = "Jersey",
  "JO" = "Jordan",
  "KZ" = "Kazakhstan",
  "KE" = "Kenya",
  "KI" = "Kiribati",
  "KP" = "Korea, Democratic People'S Republic of",
  "KR" = "Korea, Republic of",
  "KW" = "Kuwait",
  "KG" = "Kyrgyzstan",
  "LA" = "Lao People'S Democratic Republic",
  "LV" = "Latvia",
  "LB" = "Lebanon",
  "LS" = "Lesotho",
  "LR" = "Liberia",
  "LY" = "Libyan Arab Jamahiriya",
  "LI" = "Liechtenstein",
  "LT" = "Lithuania",
  "LU" = "Luxembourg",
  "MO" = "Macao",
  "MK" = "Macedonia, The Former Yugoslav Republic of",
  "MG" = "Madagascar",
  "MW" = "Malawi",
  "MY" = "Malaysia",
  "MV" = "Maldives",
  "ML" = "Mali",
  "MT" = "Malta",
  "MH" = "Marshall Islands",
  "MQ" = "Martinique",
  "MR" = "Mauritania",
  "MU" = "Mauritius",
  "YT" = "Mayotte",
  "MX" = "Mexico",
  "FM" = "Micronesia, Federated States of",
  "MD" = "Moldova, Republic of",
  "MC" = "Monaco",
  "MN" = "Mongolia",
  "MS" = "Montserrat",
  "MA" = "Morocco",
  "MZ" = "Mozambique",
  "MM" = "Myanmar",
  "NA" = "Namibia",
  "NR" = "Nauru",
  "NP" = "Nepal",
  "NL" = "Netherlands",
  "AN" = "Netherlands Antilles",
  "NC" = "New Caledonia",
  "NZ" = "New Zealand",
  "NI" = "Nicaragua",
  "NE" = "Niger",
  "NG" = "Nigeria",
  "NU" = "Niue",
  "NF" = "Norfolk Island",
  "MP" = "Northern Mariana Islands",
  "NO" = "Norway",
  "OM" = "Oman",
  "PK" = "Pakistan",
  "PW" = "Palau",
  "PS" = "Palestinian Territory, Occupied",
  "PA" = "Panama",
  "PG" = "Papua New Guinea",
  "PY" = "Paraguay",
  "PE" = "Peru",
  "PH" = "Philippines",
  "PN" = "Pitcairn",
  "PL" = "Poland",
  "PT" = "Portugal",
  "PR" = "Puerto Rico",
  "QA" = "Qatar",
  "RE" = "Reunion",
  "RO" = "Romania",
  "RU" = "Russian Federation",
  "RW" = "RWANDA",
  "SH" = "Saint Helena",
  "KN" = "Saint Kitts and Nevis",
  "LC" = "Saint Lucia",
  "PM" = "Saint Pierre and Miquelon",
  "VC" = "Saint Vincent and the Grenadines",
  "WS" = "Samoa",
  "SM" = "San Marino",
  "ST" = "Sao Tome and Principe",
  "SA" = "Saudi Arabia",
  "SN" = "Senegal",
  "CS" = "Serbia and Montenegro",
  "SC" = "Seychelles",
  "SL" = "Sierra Leone",
  "SG" = "Singapore",
  "SK" = "Slovakia",
  "SI" = "Slovenia",
  "SB" = "Solomon Islands",
  "SO" = "Somalia",
  "ZA" = "South Africa",
  "GS" = "South Georgia and the South Sandwich Islands",
  "ES" = "Spain",
  "LK" = "Sri Lanka",
  "SD" = "Sudan",
  "SR" = "Suriname",
  "SJ" = "Svalbard and Jan Mayen",
  "SZ" = "Swaziland",
  "SE" = "Sweden",
  "CH" = "Switzerland",
  "SY" = "Syrian Arab Republic",
  "TW" = "Taiwan, Province of China",
  "TJ" = "Tajikistan",
  "TZ" = "Tanzania, United Republic of",
  "TH" = "Thailand",
  "TL" = "Timor-Leste",
  "TG" = "Togo",
  "TK" = "Tokelau",
  "TO" = "Tonga",
  "TT" = "Trinidad and Tobago",
  "TN" = "Tunisia",
  "TR" = "Turkey",
  "TM" = "Turkmenistan",
  "TC" = "Turks and Caicos Islands",
  "TV" = "Tuvalu",
  "UG" = "Uganda",
  "UA" = "Ukraine",
  "AE" = "United Arab Emirates",
  "GB" = "United Kingdom",
  "US" = "United States",
  "UM" = "United States Minor Outlying Islands",
  "UY" = "Uruguay",
  "UZ" = "Uzbekistan",
  "VU" = "Vanuatu",
  "VE" = "Venezuela",
  "VN" = "Viet Nam",
  "VG" = "Virgin Islands, British",
  "VI" = "Virgin Islands, U.S.",
  "WF" = "Wallis and Futuna",
  "EH" = "Western Sahara",
  "YE" = "Yemen",
  "ZM" = "Zambia",
  "ZW" = "Zimbabwe",
}

export enum CampaignStatusE {
  "Deleted",
  "Opened",
  "Closed",
}

export enum ClientStatusE {
  "Deleted",
  "Active",
  "Disable",
}

export enum UserStatusE {
  "Enabled",
  "Disabled",
  "Deleted",
}

export enum UserStatusHeE {
  "פעיל",
  "לא פעיל",
  "נמחק",
}

export enum SortingDirectionsE {
  DESC = "desc",
  ASC = "asc",
}

export enum FileTypeE {
  // 'Advertisement Low Res' = 1,
  // 'Community time ' = 2,
  "Advertisement " = 3,
  "Sponsorship" = 4,
  "Community time" = 5,
}

export enum FileTypeHebrewE {
  // 'Advertisement Low Res' = 1,
  // 'זמן קהילה ' = 2,
  "פרסומת" = 3,
  "חסות" = 4,
  "זמן קהילה" = 5,
}

export enum FileTypeDescFromNumE {
  // 'Advertisement Low Res' = 1,
  // 'Community time ' = 2,
  "Advertisement" = 3,
  "Sponsorship" = 4,
  "Community time" = 5,
}

export enum SupportMessageStatusE {
  "Open",
  "Processed",
}

export enum AdvertiserAndBrandStatusE {
  "Pending",
  "Enabled",
  "Disabled",
}

export enum EmailStatusE {
  "Sent",
}

export enum MailRecipientE {
  "Advertisers",
  "Broadcasters",
  "Post Companies",
  "Test Email",
}

export enum LeadStatusE {
  "Open",
  "Done",
  "Not relevant",
}

export enum FTPServerE {
  "FTP",
  "FTPS",
  "SFTP",
}

export enum ProjectFileStatusE {
  // File (version) is defined but is not uploaded yet
  Waiting = 0,

  // File is being uploaded
  Uploading = 1,

  // File is successfully uploaded
  Uploaded = 2,

  // Upload of the file failed
  UploadError = 3,

  // File is sent for encoding but the encoding process isn't finished yet
  Encoding = 4,

  // The file is successfully encoded, it is possible to show low-res version on site
  Encoded = 5,

  // Encoding has failed
  EncodingError = 6,

  // Low-res version only is available, high-res version has been deleted from server
  LowResOnly = 7,

  // Both low-res and high-res versions of the files has been deleted from the server
  Deleted = 8,
}

export enum DeliveryOrderStatusE {
  "Created" = 0,
  "Pending" = 1,
  "Delivered" = 3,
  "Canceled" = 4,
  "Billed" = 5,
  "Invoice Issued" = 6,
  // Charge could not be verified against iCount; the order is NOT fulfilled (spec-13 §8).
  // Value 10 deliberately — 5 and 6 are taken and mean different things across the two order
  // enums on the backend. Never renumber.
  "Pending Verification" = 10,
  // spec-22 C5' — iCount ACTIVELY CONTRADICTED the claim (amount/currency/refund mismatch, or no
  // candidate matched), as opposed to "we could not tell" (Pending Verification = 10). Kept distinct
  // so 10 stays useful for triage instead of holding both genuine victims and tamper attempts.
  // 🔴 Must stay numerically aligned with the four backend enum mirrors. Never renumber.
  "Verification Failed" = 11,
}

// Re-delivery order/payment status (Roadmap item 8) — mirrors backend ReDeliveryOrderStatus.
export enum ReDeliveryOrderStatusE {
  "Created" = 0,
  "Pending Payment" = 1,
  "Paid" = 2,
  "Sent" = 3,
  "Canceled" = 4,
  "Invoice Issued" = 5,
  // Charge could not be verified against iCount; the order is NOT fulfilled (spec-13 §8).
  // Value 10 deliberately — see DeliveryOrderStatusE. Never renumber.
  "Pending Verification" = 10,
  // spec-22 C5' — iCount ACTIVELY CONTRADICTED the claim (amount/currency/refund mismatch, or no
  // candidate matched), as opposed to "we could not tell" (Pending Verification = 10). Kept distinct
  // so 10 stays useful for triage instead of holding both genuine victims and tamper attempts.
  // 🔴 Must stay numerically aligned with the four backend enum mirrors. Never renumber.
  "Verification Failed" = 11,
}

export enum ProjectFileBroadcasterRejectReason {
  Technical = 0,
  Other = 1,
}

export enum ProjectFileBroadcasterRejectType {
  Private = 0,
  Public = 1,
}

export enum CampaignWizardMode {
  CREATE,
  EDIT,
  SHORT_EDIT,
  COPY,
  CAMPAIGN_EDIT,
  CAMPAIGN_COPY,
  ADD_VERSIONS,
}

export enum ActivityLogEntryModeE {
  ApprovedByPostCompany = 0, //Delivery approved by post-company

  ApprovedByAdvertisingAgency = 1, //Delivery approved by ad-agency

  ApprovedByAdvertiser = 2, //Delivery approved by the advertiser

  CancelledByAdvertisingAgency = 3, //Delivery canceled

  DeletedByAdvertisingAgency = 4, //Delivery deleted by the advertiser

  RejectedByBroadcaster = 5, //Delivery declined by the broadcaster

  OpenedByAdvertisingAgency = 6, //Delivery opened by the advertiser

  DeliveryServiceApproval = 7, //Delivery service approval

  DownloadedByBroadcaster = 8, //not work

  DownloadedByAllBroadcasters = 9, //not work

  Closed = 10,
}

export enum ProductTourActionsE {
  NAVIGATE_TO_DELIVERY = "navigateToDelivery",
}

/**
 * Whether the welcome message / guided tour is holding the screen. The tour renders above every
 * popup in the app, so anything else that wants to open a window on load (today: the global
 * notification popup from Manage → Global settings) waits for this gate to clear.
 */
export enum TourGateStatusE {
  // We don't know yet whether this user gets the tour — nothing may open a window.
  Pending = "pending",
  // The welcome message or a tour step is on screen.
  Blocking = "blocking",
  // The tour was dismissed, completed, or never applies to this user — the screen is free.
  Cleared = "cleared",
}

export enum PaymentStatusesE {
  ToBeCharged,
  ProformaInvoice,
  Billed,
  NoCharge,
}

export enum PaymentMethodsE {
  CreditCard,
  WireTransfer,
  Check,
}

export enum PaymentTermsE {
  Current,
  Current30,
  Current60,
  Current90,
  Current120,
}

export enum ClientCurrencyE {
  NIS,
  USD,
  EUR,
}

export enum CurrencySymbolsE {
  NIS = "₪",
  ILS = "₪",
  USD = "$",
  EUR = "€",
}

export const Currency = ["₪", "$", "€"];

export const CurrencyAbbs = ["NIS", "USD", "EUR"];

export enum ContactsPageTypeE {
  CONTACT,
  SUPPORT,
}

export enum VideoGuideStatusE {
  NOT_ACTIVE,
  ACTIVE,
  TEST,
}

// Search-results page presentation toggle: collapse matched deliveries by campaign, or list deliveries.
export enum SearchViewE {
  Campaigns = "campaigns",
  Deliveries = "deliveries",
}

// spec-49 — the versions library (/versions). Values are URL/localStorage tokens and the backend sort keys
// (VersionLibraryQueryParser.ParseSort): keep them in sync with the backend.
export enum VersionsViewE {
  Table = "table",
  // CORRECTIONS-02 Task 12 - Eran: "change the thinking from Gallery display mode to Tiles".
  // Links and saved preferences written before this round say "gallery"; versionsViewStorage
  // .normaliseView maps them forward rather than dropping the user back to Table.
  Tiles = "tiles",
}

export enum VersionsSortE {
  DeliveryDesc = "delivery_desc",
  DeliveryAsc = "delivery",
  BroadcastDateDesc = "bdate_desc",
  BroadcastDateAsc = "bdate",
  NameAsc = "name",
}
